var path = 'batch/objectRestore/info/objectRestoreInfo.tpl.html';
var html = "<react-component name=\"object-restore-info\"/>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;